const PERSONA_TO_ENGLISH_ASSESSMENT: Record<string, string> = {
  english_technician_v1: "english_technician_v1",
  english_lead_technician_v1: "english_lead_technician_v1",
  english_assistant_engineer_v1: "english_assistant_engineer_v1"
};

export const SIGNUP_PERSONA_OPTIONS: Array<{ title: string; value: string }> = [
  { title: "Technician", value: "english_technician_v1" },
  { title: "Lead Technician", value: "english_lead_technician_v1" },
  {
    title: "Assistant Engineer",
    value: "english_assistant_engineer_v1"
  }
];

export function resolveEnglishAssessmentTypeByPersona(
  persona: string | null | undefined,
  defaultAssessmentType: string | null | undefined
): string {
  const normalizedPersona = String(persona || "").trim();
  if (normalizedPersona && PERSONA_TO_ENGLISH_ASSESSMENT[normalizedPersona]) {
    return PERSONA_TO_ENGLISH_ASSESSMENT[normalizedPersona];
  }
  return String(defaultAssessmentType || "").trim();
}
